import { hasDebugHash, isSSR } from './src/utils/helpers';

(function () {
    if (process.env.NODE_ENV !== 'development') {
        // Save the original method in a private variable
        const _originalDebug = console.debug;

        // Redefine console.debug method with a custom function
        if (!isSSR()) {
            if (hasDebugHash()) {
                console.debug = function () {
                    // eslint-disable-next-line prefer-rest-params
                    _originalDebug.apply(console, arguments);
                };
                return;
            }
            console.debug = function () {
                return;
            };
            window.console.debug = function () {
                return;
            };
        }
    }
})();
